// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aJkN","content":"styles_content__Ftzfb","tableWrap":"styles_tableWrap__wCgoA"};